<div class="oauth2-settings-container">
  <h3>OAuth2 Sessions</h3>
  @if (clientSessionDict) {
    <div class="session-card-list">
      @for (kvPair of clientSessionDict | keyvalue; track kvPair) {
        <div class="session-card ui segment">
          <h3><a class="anchor-button" (click)="viewClient(kvPair.value.client)">{{ kvPair.value.client.client_name }}</a></h3>
          <div class="client-owner">Provided by {{kvPair.value.client.owner || 'unknown'}}</div>
          @if (kvPair.value.client.client_id) {
            <button class="ui mini red button revoke-button"
            (click)="revokeClient(kvPair.value.client.client_id)">Revoke</button>
          }
          <div class="ui divider"></div>
          <div class="session-list">
            <span>All Sessions: </span>
            <button class="ui tiny button" (click)="toggle(kvPair.key)">
              <i [ngClass]="{up: expandDict[kvPair.key], down: !expandDict[kvPair.key]}" class="angle icon"></i>
              {{ expandDict[kvPair.key] ? 'Collapse' : 'Expand'}}
            </button>
            @if (expandDict[kvPair.key]) {
              <ul class="ui list">
                @for (session of kvPair.value.consentSessionList; track session) {
                  <li>Authorized at {{session.handled_at}}</li>
                }
              </ul>
            }
          </div>
          <!--      <button class="ui mini red button logout-button" (click)="logoutSession(session)">Logout</button>-->
        </div>
      }
    </div>
  }
</div>
